import { BayStatusTypes } from "@/common/enums";
import Helper from "@/common/helper.js"

// A piece of device-contributed display info about a bay (e.g. Inrange's pincode, or a
// future device's session code / time remaining). The server sends whatever each device
// surfaces; the UI renders them generically, so no per-device fields are hardcoded here.
export class BayStatusDetail {
    deviceType: number = 0
    key: string = ""
    label: string = ""
    value: string = ""
}

export default class BayStatus {
    id: number = -1;
    status: BayStatusTypes = BayStatusTypes.Unknown
    details: BayStatusDetail[] = []
    hasTracker: boolean = false
    hasTeeBox: boolean = false
    // The current InUse session's time range - null unless status is InUse.
    startTimestamp: number | null = null
    endTimestamp: number | null = null

    // Only meaningful while the bay is actually InUse - null otherwise, since there's no
    // current session to show a range for.
    get timeRangeDisplay(): string | null {
        if (!this.startTimestamp || !this.endTimestamp)
            return null

        let start = Helper.convertUTCDateToLocalDate(new Date(this.startTimestamp))
        let end = Helper.convertUTCDateToLocalDate(new Date(this.endTimestamp))
        let format = { hour: '2-digit', minute: '2-digit' } as const
        return `${start.toLocaleTimeString([], format)} - ${end.toLocaleTimeString([], format)}`
    }

    get statusDisplay(): string {
        switch (this.status) {
            case BayStatusTypes.Available:
            return "Available"

            case BayStatusTypes.InUse:
            return "In Use"

            case BayStatusTypes.Cleaning:
            return "Cleaning"

            case BayStatusTypes.OutOfOrder:
            return "Out of Order"

            case BayStatusTypes.Conflicted:
            return "Conflicted"

            case BayStatusTypes.NothingToActivate:
            return "No Devices"

            case BayStatusTypes.Unknown:
            default:
            return "Unknown"
        }
    }

    get statusColor(): string {
        switch (this.status) {
            case BayStatusTypes.Available:
            return "#d4edda"

            case BayStatusTypes.InUse:
            return "#f8d7da"

            case BayStatusTypes.Cleaning:
            return "#fff3cd"

            case BayStatusTypes.OutOfOrder:
            return "#d6d8d9"

            case BayStatusTypes.Conflicted:
            return "#ffe0b2"

            case BayStatusTypes.NothingToActivate:
            return "#d6d8d9"

            case BayStatusTypes.Unknown:
            default:
            return "Unknown"
        }
    }


    static from(json: string): BayStatus {
        return Object.assign(new BayStatus(), json);
    }
}
